import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=2b5de386&scoped=true"
import script from "./TabPane.vue?vue&type=script&lang=js"
export * from "./TabPane.vue?vue&type=script&lang=js"
import style0 from "./TabPane.vue?vue&type=style&index=0&id=2b5de386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5de386",
  null
  
)

export default component.exports